import { gql } from '@apollo/client';
import {
    META_PAGE_FILTER_FRAGMENT,
    META_PAGE_TOTAL_FRAGMENT,
} from 'apollo/metaPage/metaPage.fragment';
import { SAMPLE_FRAGMENT } from 'apollo/sample/sample.fragment';
import { USER_COLLECTION_FRAGMENT } from './userCollection.fragment';

export const UserCollection = gql`
    query UserCollection($collectionGuid: ID) {
        userCollection(collectionGuid: $collectionGuid) {
            ...UserCollectionFragment
        }
    }
    ${USER_COLLECTION_FRAGMENT}
`;

export const DeleteUserCollection = gql`
    mutation DeleteUserCollection($collectionGuid: ID) {
        deleteUserCollection(collectionGuid: $collectionGuid)
    }
`;

export const UserCollectionsFeed = gql`
    query UserCollectionsFeed(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        userCollectionsFeed(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            feed(take: $take, page: $page, query: $query, offset: $offset) {
                ...UserCollectionFragment
            }
            meta {
                ...MetaPageTotalFragment
                ...MetaPageFilterFragment
            }
        }
    }
    ${USER_COLLECTION_FRAGMENT}
    ${META_PAGE_TOTAL_FRAGMENT}
    ${META_PAGE_FILTER_FRAGMENT}
`;

export const PaginatedUserCollections = gql`
    query PaginatedUserCollections(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedUserCollections(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ...UserCollectionFragment
            }
            meta {
                ...MetaPageTotalFragment
                ...MetaPageFilterFragment
            }
        }
    }
    ${USER_COLLECTION_FRAGMENT}
    ${META_PAGE_TOTAL_FRAGMENT}
    ${META_PAGE_FILTER_FRAGMENT}
`;

export const PaginatedUserCollectionSamples = gql`
    query PaginatedUserCollectionSamples(
        $collectionGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedUserCollectionSamples(
            collectionGuid: $collectionGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                ...SampleFragment
            }
            meta {
                ...MetaPageTotalFragment
                ...MetaPageFilterFragment
            }
            next {
                skip
            }
        }
    }
    ${SAMPLE_FRAGMENT}
    ${META_PAGE_TOTAL_FRAGMENT}
    ${META_PAGE_FILTER_FRAGMENT}
`;

export const EditUserCollection = gql`
    mutation EditUserCollection($collectionGuid: ID, $name: String) {
        editUserCollection(collectionGuid: $collectionGuid, name: $name)
    }
`;

export const CreateUserCollection = gql`
    mutation CreateUserCollection($name: String, $sampleCount: Int) {
        createUserCollection(name: $name, sampleCount: $sampleCount) {
            guid
            name
        }
    }
`;

export const AddSamplesToUserCollection = gql`
    mutation AddSamplesToUserCollection($sampleIds: [ID], $collectionGuid: ID) {
        addSamplesToUserCollection(
            sampleIds: $sampleIds
            collectionGuid: $collectionGuid
        ) {
            guid
        }
    }
`;

export const RemoveSamplesFromUserCollection = gql`
    mutation RemoveSamplesFromUserCollection(
        $sampleIds: [ID]
        $collectionGuid: ID
    ) {
        removeSamplesFromUserCollection(
            sampleIds: $sampleIds
            collectionGuid: $collectionGuid
        ) {
            guid
        }
    }
`;
